<template>
    <a-modal
        title="编辑收入明细"
        :visible="visible"
        @ok="handleOk"
        @cancel="handleCancel"
        okText="保存"
        cancelText="取消"
        width="75%"
        :confirmLoading="saving"
        :destroyOnClose="true"
        :body-style="{ padding: '16px' }"
    >
        <a-form-model :model="editForm" ref="editFormRef" :label-col="{ style: { width: '100px' } }" :wrapper-col="{ style: { width: 'calc(100% - 100px)' } }">
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="凭证号">
                        <a-input v-model="editForm.voucherNo" placeholder="凭证号" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="收款处理单">
                        <a-input v-model="editForm.receiptFormNo" placeholder="收款处理单" />
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="金蝶应收单据号">
                        <a-input v-model="editForm.kingdeeReceivableNo" placeholder="金蝶应收单据号" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="客商">
                        <a-select
                            v-model="editForm.customerId"
                            placeholder="请输入客商名称搜索"
                            show-search
                            allow-clear
                            :filter-option="false"
                            :not-found-content="clientSearching ? '搜索中...' : (clientList.length === 0 ? '未找到匹配的客商' : undefined)"
                            @search="handleClientSearch"
                            @change="onCustomerChange"
                        >
                            <a-select-option v-for="item in clientList" :key="item.id" :value="item.id">
                                {{ item.custName }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="发票号">
                        <a-select
                            v-model="editForm.invoiceNo"
                            placeholder="请输入发票号搜索"
                            show-search
                            allow-clear
                            :filter-option="false"
                            :not-found-content="invoiceSearching ? '搜索中...' : (invoiceList.length === 0 ? '未找到匹配的发票' : undefined)"
                            @search="handleInvoiceSearch"
                        >
                            <a-select-option v-for="item in invoiceList" :key="item.id" :value="item.invoiceCode">
                                {{ item.invoiceCode }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="收费日期">
                        <a-date-picker
                            v-model="editForm.chargeDate"
                            style="width: 100%"
                            placeholder="请选择收费日期"
                            value-format="YYYY-MM-DD"
                        />
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="项目编码">
                        <a-select
                            v-model="editForm.contractId"
                            placeholder="请输入项目名称搜索"
                            show-search
                            allow-clear
                            :filter-option="false"
                            :not-found-content="contractSearching ? '搜索中...' : (contractList.length === 0 ? '未找到匹配的合同' : undefined)"
                            @search="handleContractSearch"
                            @change="onProjectChange"
                        >
                            <a-select-option v-for="item in contractList" :key="item.id" :value="item.id">
                                {{ item.code }} - {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="回款金额(元)">
                        <a-input-number
                            v-model="editForm.amount"
                            style="width: 100%"
                            :min="0"
                            :precision="2"
                            placeholder="回款金额"
                            disabled
                        />
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="流水来源">
                        <a-input v-model="editForm.source" placeholder="流水来源" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="责任部门">
                        <a-select
                            v-model="editForm.deptId"
                            placeholder="请选择责任部门"
                            show-search
                            :filter-option="$selectFilterOption"
                            allow-clear
                            @change="onDeptChange"
                        >
                            <a-select-option v-for="item in organizationList" :key="item.id" :value="item.id">
                                {{ item.uniqueName }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row :gutter="16">
                <a-col :span="12">
                    <a-form-model-item label="收入性质">
                        <a-select
                            v-model="editForm.incomeType"
                            placeholder="请选择收入性质"
                            allow-clear
                        >
                            <a-select-option v-for="item in incomeTypeList" :key="item.value" :value="item.value">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="备注">
                        <a-input v-model="editForm.remark" placeholder="备注" />
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
    </a-modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import organization from "@/mixins/organization";
import { fetchList as fetchClientList, fetchDetail as fetchClientDetail } from "@/api/setting/company";
import { fetchList as fetchInvoiceList, fetchDetail as fetchInvoiceDetail } from "@/api/invoice";
import { fetchList as fetchContractList, fetchDetail as fetchContractDetail } from "@/api/contract";
import { updateIncomeDetail } from "@/api/finance/income-detail";

export default {
    name: "IncomeEditModal",
    props: {
        visible: { type: Boolean, default: false },
        record: { type: Object, default: () => ({}) }
    },
    mixins: [organization],
    data() {
        return {
            saving: false,
            clientList: [],
            clientSearching: false,
            invoiceList: [],
            invoiceSearching: false,
            contractList: [],
            contractSearching: false,
            editForm: {
                id: "",
                voucherNo: "",
                receiptFormNo: "",
                kingdeeReceivableNo: "",
                customerName: "",
                customerId: "",
                invoiceNo: "",
                chargeDate: null,
                contractId: "",
                amount: null,
                source: "",
                deptName: "",
                deptId: "",
                incomeType: "",
                remark: ""
            }
        };
    },
    computed: {
        ...mapState("organization", ["organizationList"]),
        ...mapGetters("setting", ["findDataDict"]),
        incomeTypeList() {
            return this.findDataDict("incomeType") || [];
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.initForm();
                this.loadInitialClients();
                this.loadInitialInvoices();
                this.loadInitialContracts();
            }
        }
    },
    methods: {
        ...mapActions("organization", ["getOrganizationList"]),
        initForm() {
            const r = this.record || {};
            const dept = this.organizationList.find(item => item.uniqueName === r.deptName);
            this.editForm = {
                id: r.id || "",
                voucherNo: r.voucherNo || "",
                receiptFormNo: r.receiptFormNo || "",
                kingdeeReceivableNo: r.kingdeeReceivableNo || "",
                customerName: r.customerName || "",
                customerId: r.customerId || "",
                invoiceNo: r.invoiceNo || "",
                chargeDate: r.chargeDate || null,
                contractId: r.contractId || "",
                amount: r.amount ?? null,
                source: r.source || "",
                deptName: r.deptName || "",
                deptId: r.deptId || (dept ? dept.id : ""),
                incomeType: r.incomeType || "",
                remark: r.remark || ""
            };

            // 如果记录已有客商名但没有 customerId，按名称搜索并自动选中
            if (r.customerName && !r.customerId) {
                this.searchAndSelectClient(r.customerName);
            }
            // 发票号搜索回显
            if (r.invoiceNo) {
                this.handleInvoiceSearch(r.invoiceNo);
            }
            // 合同搜索回显
            if (r.contractName || r.contractCode) {
                this.handleContractSearch(r.contractName || r.contractCode);
            }
        },
        // ---- 客商远程搜索 ----
        async loadInitialClients() {
            try {
                const res = await fetchClientList({ pageNum: 1, pageSize: 50 });
                this.clientList = res?.list || [];
                // 如果已有客户名，在初始列表中匹配并选中
                this.tryAutoSelectClient();
                // 如果 customerId 存在但初始列表中没有，按 ID 补查
                if (this.editForm.customerId) {
                    const exists = this.clientList.some(item => item.id === this.editForm.customerId);
                    if (!exists) {
                        const detail = await fetchClientDetail({ id: this.editForm.customerId });
                        if (detail) {
                            this.clientList.unshift(detail);
                        }
                    }
                }
            } catch (e) {
                console.error("获取客商列表失败", e);
            }
        },
        async handleClientSearch(value) {
            if (!value) return;
            this.clientSearching = true;
            try {
                const res = await fetchClientList({ name: value, pageNum: 1, pageSize: 20 });
                this.clientList = res?.list || [];
            } catch (e) {
                console.error("搜索客商失败", e);
            } finally {
                this.clientSearching = false;
            }
        },
        // 初始列表中若有匹配的客户名，自动选中
        tryAutoSelectClient() {
            if (!this.editForm.customerId && this.editForm.customerName) {
                const matched = this.clientList.find(
                    item => item.custName === this.editForm.customerName
                );
                if (matched) {
                    this.editForm.customerId = matched.id;
                }
            }
        },
        async searchAndSelectClient(name) {
            if (!name) return;
            this.clientSearching = true;
            try {
                const res = await fetchClientList({ name, pageNum: 1, pageSize: 20 });
                this.clientList = res?.list || [];
                // 在搜索结果中匹配客商名，自动选中
                const matched = this.clientList.find(
                    item => item.custName === name || item.custName?.includes(name) || name?.includes(item.custName)
                );
                if (matched) {
                    this.editForm.customerId = matched.id;
                    this.editForm.customerName = matched.custName;
                }
            } catch (e) {
                console.error("搜索客商失败", e);
            } finally {
                this.clientSearching = false;
            }
        },
        onCustomerChange(value) {
            const client = this.clientList.find(item => item.id === value);
            this.editForm.customerName = client ? client.custName : "";
        },
        // ---- 发票远程搜索 ----
        async loadInitialInvoices() {
            try {
                const res = await fetchInvoiceList({ pageNum: 1, pageSize: 50 });
                this.invoiceList = res?.list || [];
                // 如果 invoiceNo 存在但列表中无匹配，按发票号补搜
                if (this.editForm.invoiceNo) {
                    const exists = this.invoiceList.some(item => item.invoiceCode === this.editForm.invoiceNo);
                    if (!exists) {
                        await this.handleInvoiceSearch(this.editForm.invoiceNo);
                    }
                }
            } catch (e) {
                console.error("获取发票列表失败", e);
            }
        },
        async handleInvoiceSearch(value) {
            if (!value) return;
            this.invoiceSearching = true;
            try {
                const res = await fetchInvoiceList({ invoiceCode: value, pageNum: 1, pageSize: 20 });
                this.invoiceList = res?.list || [];
            } catch (e) {
                console.error("搜索发票失败", e);
            } finally {
                this.invoiceSearching = false;
            }
        },
        // ---- 合同远程搜索 ----
        async loadInitialContracts() {
            try {
                const res = await fetchContractList({ pageNum: 1, pageSize: 50 });
                this.contractList = res?.list || [];
                // 如果 contractId 存在但列表中无匹配，按 ID 补查
                if (this.editForm.contractId) {
                    const exists = this.contractList.some(item => item.id === this.editForm.contractId);
                    if (!exists) {
                        const detail = await fetchContractDetail(this.editForm.contractId);
                        if (detail) {
                            this.contractList.unshift(detail);
                        }
                    }
                }
            } catch (e) {
                console.error("获取合同列表失败", e);
            }
        },
        async handleContractSearch(value) {
            if (!value) return;
            this.contractSearching = true;
            try {
                const res = await fetchContractList({ name: value, pageNum: 1, pageSize: 20 });
                this.contractList = res?.list || [];
            } catch (e) {
                console.error("搜索合同失败", e);
            } finally {
                this.contractSearching = false;
            }
        },
        onProjectChange(value) {
            const project = this.contractList.find(item => item.id === value);
            if (project) {
                this.$set(this.editForm, 'contractId', value);
            }
        },
        // ---- 部门选择 ----
        onDeptChange(value) {
            const dept = this.organizationList.find(item => item.id === value);
            this.editForm.deptName = dept ? dept.uniqueName : "";
        },
        // ---- 保存 ----
        async handleOk() {
            if (!this.editForm.id) {
                this.$message.error("缺少记录ID，无法保存");
                return;
            }

            // 如果没选部门但填了部门名，补充deptId
            if (!this.editForm.deptId && this.editForm.deptName) {
                const dept = this.organizationList.find(item => item.uniqueName === this.editForm.deptName);
                if (dept) {
                    this.editForm.deptId = dept.id;
                }
            }

            const payload = {
                id: this.editForm.id,
                voucherNo: this.editForm.voucherNo,
                receiptFormNo: this.editForm.receiptFormNo,
                kingdeeReceivableNo: this.editForm.kingdeeReceivableNo,
                customerName: this.editForm.customerName,
                customerId: this.editForm.customerId,
                invoiceNo: this.editForm.invoiceNo,
                chargeDate: this.editForm.chargeDate,
                contractId: this.editForm.contractId,
                amount: this.editForm.amount,
                source: this.editForm.source,
                deptName: this.editForm.deptName,
                deptId: this.editForm.deptId,
                incomeType: this.editForm.incomeType,
                remark: this.editForm.remark
            };

            this.saving = true;
            try {
                await updateIncomeDetail(payload);
                this.$message.success("保存成功");
                this.$emit("ok");
                this.$emit("close");
            } catch (e) {
                console.error("保存失败", e);
                this.$message.error("保存失败：" + (e.message || "系统异常"));
            } finally {
                this.saving = false;
            }
        },
        handleCancel() {
            this.$emit("close");
        }
    }
};
</script>
